<template>
	<div class="px-3 pt-0 pb-3">
		<!-- 视图切换胶囊组件 -->
		<div class="uplimit-toggle-container">
			<div class="uplimit-toggle-pill">
				<button 
					:class="{ active: currentView === 'tier' }" 
					@click="switchView('tier')" 
					class="toggle-btn"
				>
					<span class="dot-indicator"></span>区间梯队 (单日)
				</button>
				<button 
					:class="{ active: currentView === 'multi_day' }" 
					@click="switchView('multi_day')" 
					class="toggle-btn"
				>
					<span class="dot-indicator"></span>涨幅天梯 (多日)
				</button>
			</div>
		</div>

		<!-- 梯队视图主体 -->
		<keep-alive>
			<PctTierView v-if="currentView === 'tier'" @show_sidebar="show_sidebar" key="tier"></PctTierView>
			<PctTierMultiDayLadder v-else-if="currentView === 'multi_day'" @show_sidebar="show_sidebar" key="multi_day"></PctTierMultiDayLadder>
		</keep-alive>

		<!-- 共享个股右侧抽屉 -->
		<StockInfoSidebar 
			:symbol_code="symbol_code" 
			:symbol_name="symbol_name" 
			:date_mark="date_mark" 
			@date-mark-change="onDateMarkChange"
		></StockInfoSidebar>
	</div>
</template>

<script>
import PctTierView from 'components/uplimit/PctTierView.vue'
import PctTierMultiDayLadder from 'components/uplimit/PctTierMultiDayLadder.vue'
import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'

export default {
	name: 'ReviewUpLimitTier',
	data () {
		return {
			currentView: 'multi_day', // 默认展示多日天梯
			symbol_code: '603069',
			symbol_name: '',
			date_mark: ''
		}
	},
	components: {
		PctTierView,
		PctTierMultiDayLadder,
		StockInfoSidebar
	},
	mounted () {
		const savedView = localStorage.getItem('pct_tier_view_mode')
		if (savedView) {
			this.currentView = savedView
		}
	},
	methods: {
		switchView (view) {
			this.currentView = view
			localStorage.setItem('pct_tier_view_mode', view)
		},
		show_sidebar (stock_info) {
			this.symbol_code = stock_info['stock_code']
			this.symbol_name = stock_info['stock_name']
			this.date_mark = stock_info['date1'] || this.date_mark || ''
		},
		onDateMarkChange (date) {
			this.date_mark = date || ''
		}
	}
}
</script>

<style scoped>
.uplimit-toggle-container {
	display: flex;
	justify-content: flex-start;
	padding: 8px 4px 12px 4px;
}

.uplimit-toggle-pill {
	display: flex;
	background: var(--bg-muted, #1a2333);
	border: 1px solid var(--border-color, #2d3748);
	padding: 4px;
	border-radius: 999px;
	box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}

.toggle-btn {
	border: none;
	background: transparent;
	padding: 6px 18px;
	border-radius: 999px;
	font-size: 13px;
	font-weight: 500;
	color: var(--text-muted, #94a3b8);
	cursor: pointer;
	transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	outline: none;
	display: flex;
	align-items: center;
	gap: 6px;
}

.toggle-btn:hover {
	color: var(--text-main, #f1f5f9);
}

.toggle-btn.active {
	background: var(--bg-card, #1e2638);
	color: var(--accent-color, #3b82f6);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
	font-weight: 600;
}

.dot-indicator {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: transparent;
	transition: all 0.25s ease;
}

.toggle-btn.active .dot-indicator {
	background-color: var(--accent-color, #3b82f6);
	box-shadow: 0 0 6px var(--accent-color, #3b82f6);
}

@media (max-width: 576px) {
	.toggle-btn {
		padding: 5px 12px;
		font-size: 12px;
	}
}
</style>
